import { useEffect, useRef } from 'react';

import useScriptLoader, { SCRIPTS } from '~/context/ScriptLoader/useScriptLoader';

export const isFormulaRegExp = /(\\\[.*\\])|(\\\(.*\\\))|(\$\$.*\$\$)|(<formula>.*<\\formula>)/g;
const useMathJaxScriptLoader = (skip = false) => {
  const nodeRef = useRef(null);
  const { isLoaded } = useScriptLoader(SCRIPTS.MATH_JAX, skip);

  useEffect(() => {
    //check if script url exists and script not loaded yet
    if (!isLoaded) {
      //mathjax config
      //@ts-ignore
      window.MathJax = {
        tex: {
          inlineMath: [['\\(', '\\)']],
          displayMath: [
            ['$$', '$$'],
            ['\\[', '\\]'],
            ['<formula>', '</formula>'],
          ],
        },
      };
    }
  }, [isLoaded]);

  useEffect(() => {
    // @ts-ignore:
    window?.MathJax?.typesetPromise?.([nodeRef.current]);
  }, [isLoaded, nodeRef]);

  return nodeRef;
};

export default useMathJaxScriptLoader;
